import { Button, Form, Space, Typography } from 'antd'
import { GenericRequestProps } from './types'
import { useForm } from 'antd/lib/form/Form'
import NotGuaranteed from '../NotGuaranteed'
import { useEffect } from 'react'
import { elapsed } from 'shared'
import { Store } from 'antd/lib/form/interface'

function GenericRequest<T extends Store>({
  estimatesAreCalculatedBy,
  initialValues,
  onRequest,
  request,
  children,
  loading,
  warning,
  reduceEstimatesBy,
  errorMessagesInclude,
}: GenericRequestProps<T>) {
  const [form] = useForm()
  // reset initial values
  useEffect(() => {
    form.resetFields()
  }, [form, initialValues])
  return (
    <Space size="middle" direction="vertical" style={{ width: '50%' }}>
      {warning && (
        <Typography.Text>
          <Typography.Text strong type="warning">
            WARNING!
          </Typography.Text>{' '}
          {warning}
        </Typography.Text>
      )}

      <Typography.Text>
        Request multiple {request.type} all at once with a {request.name}. Only{' '}
        <Typography.Text underline strong>
          one
        </Typography.Text>{' '}
        export may be generated,{' '}
        {request.blocking ? 'across all projects' : 'per project'}, at a time.
      </Typography.Text>

      <Typography.Text>
        Estimates are calculated by {estimatesAreCalculatedBy}.
      </Typography.Text>

      {request.blocking ? null : (
        <Typography.Text>
          Any request that would take more than{' '}
          {
            elapsed({
              milliseconds: request.maxMilliseconds ?? 1000 * 60 * 60 * 1,
            }).formatted
          }{' '}
          to complete will be rejected
          {reduceEstimatesBy && <>. Reduce estimates by {reduceEstimatesBy}</>}.
        </Typography.Text>
      )}

      <NotGuaranteed />

      <Typography.Text>
        On completion, an email will be sent to the requestor, instructing them
        where to get the resulting archive. If there were any errors during
        execution, they will be included in the email.
      </Typography.Text>

      {errorMessagesInclude && (
        <Typography.Text>
          Error messages include {errorMessagesInclude}.
        </Typography.Text>
      )}

      <Button
        loading={loading}
        disabled={loading}
        type="primary"
        onClick={async () => {
          try {
            const validated = await form.validateFields()
            return onRequest(validated)
          } catch (err) {}
        }}
      >
        Request
      </Button>
      <Form form={form} initialValues={initialValues}>
        {children}
      </Form>
    </Space>
  )
}

export default GenericRequest
